import { useCallback, useState } from 'react';
import type { ApiResponse } from '../services/genesisApi/httpsMethods';

export interface ErrorDialogState {
    open: boolean;
    apiResponse?: ApiResponse<any>;
    customMessage?: string;
    title?: string;
}

export const useErrorDialog = () => {
    const [errorDialog, setErrorDialog] = useState<ErrorDialogState>({
        open: false,
    });
    const showError = useCallback((
        apiResponse?: ApiResponse<any>,
        customMessage?: string,
        title?: string
    ) => {
        setErrorDialog({
            open: true,
            apiResponse,
            customMessage,
            title,
        });
    }, []);

    const showErrorFromResponse = useCallback((response?: ApiResponse<any>) => {
        if (response && !response.success) {
            showError(response);
        } else if (!response) {
            showError(undefined, 'An unexpected error occurred. Please try again.');
        }
    }, [showError]);

    const hideError = useCallback(() => {
        setErrorDialog({
            open: false,
        });
    }, []);

    return {
        errorDialog,
        showError,
        showErrorFromResponse,
        hideError,
    };
};
